
import React, { createContext, useContext, useState } from 'react';

const HvStateContext = createContext(null);


export function HorizontalFormContextProvider({ children }) {
  // This object represents your global state
  const [hvInputsValues, setHvInputsValues] = useState({});

  return (
    <HvStateContext.Provider value={{ hvInputsValues, setHvInputsValues }}>
      {children}
    </HvStateContext.Provider>
  );
}


export function useHvStateContext() {
  const ctx = useContext(HvStateContext);
  if (!ctx) throw new Error('useStateContext must be used inside <StateProvider>');
  return ctx;
}